import React, {memo, useCallback, useEffect, useState} from 'react';
import '../ScenarioTriggerCreateScreen/index.scss';
import './index.scss';

import iconCancel from '../../assets/images/icons/scenario/cancel.png';
import iconSave from '../../assets/images/icons/scenario/save.png';
import iconScenario from '../../assets/images/icons/scenario/scenario.png';
import {
    ScenarioModel,
} from '../../store/control/state';
import {useDispatch, useSelector} from 'react-redux';
import {useRPC} from '../../hooks/rpc';
import {useMessage} from '../../hooks/message';
import {onClickHandler} from '../../utils/onclick';
import {toggleScenarioTriggerInputScreenAction} from '../../store/ui/actions';
import {useLocalization} from "../../hooks/localization";

export const ScenarioTriggerControlUpdateScreen = memo(function ScenarioTriggerControlUpdateScreen() {
    const {t} = useLocalization();
    const scenarios = useSelector(state => state.control.scenarioList);
    const selectedTrigger = useSelector(state => state.ui.triggerControlScreen.selectedTrigger);
    const selectedSTPUIEntity = useSelector(state => state.ui.triggerControlScreen.selectedUIEntity);

    const dispatch = useDispatch();
    const {failure} = useMessage();
    const [rpc] = useRPC();

    const [selectedScenario, setSelectedScenario] = useState<ScenarioModel>(null);

    useEffect(() => {
        for (const scenario of scenarios) {
            if (selectedTrigger?.relational_id === scenario.id || selectedSTPUIEntity?.relational_id === scenario.id) {
                setSelectedScenario(scenario);
                break;
            }
        }
    }, [scenarios, selectedSTPUIEntity, selectedTrigger]);

    const close = useCallback(() => {
        dispatch(toggleScenarioTriggerInputScreenAction(null));
    }, [dispatch]);

    const save = useCallback(() => {
        const selectedScenarioId = selectedScenario ? selectedScenario.id : null;
        if (selectedTrigger) {
            rpc.updateScenarioTriggerControl(selectedTrigger?.id, selectedScenarioId).then(close).catch(failure);
        } else {
            rpc.updateSTPUI({
                ...selectedSTPUIEntity,
                relational_id: selectedScenarioId,
            })
                .then(close)
                .catch(failure);
        }
    }, [selectedScenario, selectedTrigger, rpc, close, failure, selectedSTPUIEntity]);

    return (
        <div className='content-page scenario-trigger-control-update-screen'>
            <div className='content-divider top'>
                <div className='content-divider left'>
                    <div className='content-top'>
                        <div className='content-wrapper'>
                            <div className='action-row'>
                                <div className='action' {...onClickHandler(close)}>
                                    <img src={iconCancel} alt=''/>
                                    <span>{t('CANCEL')}</span>
                                </div>
                                <span>{selectedTrigger?.name || selectedSTPUIEntity?.display_name}</span>
                                <div className='action' {...onClickHandler(save)}>
                                    <img src={iconSave} alt=''/>
                                    <span>{t('SAVE')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='content-divider right'>
                    <div
                        className='content-wrapper' {...onClickHandler(() => setSelectedScenario(null))}>
                        <div className='left-container'>
                            <img src={iconScenario} alt=''/>
                            <span>{t('NONE')}</span>
                        </div>
                        <div className={'check-box' + (selectedScenario === null ? ' checked' : '')}/>
                    </div>
                    {
                        scenarios.map(scenario => (
                            <div
                                className='content-wrapper' {...onClickHandler(() => setSelectedScenario(scenario))}>
                                <div className='left-container'>
                                    <img src={iconScenario} alt=''/>
                                    <span>{scenario.name}</span>
                                </div>
                                <div className={'check-box' + (selectedScenario === scenario ? ' checked' : '')}/>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
});
